/* =====================================================================
   MAVORA – PAGE SCRIPT (no dependencies)
   Drawers · gallery · variant picker · bundle offers · add to cart ·
   buy now · cart drawer · delivery dates · sticky bar · back to top
   ===================================================================== */
(function () {
  'use strict';
  var M = window.Mavora = window.Mavora || {};
  var routes = function () { return M.routes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cartJs: '/cart.js', cart: '/cart', root: '/' }; };
  document.documentElement.classList.add('mv-js');

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents || 0, 10);
    format = format || M.moneyFormat || '€{{amount_with_comma_separator}}';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return fmt(cents, 2);
        case 'amount_no_decimals': return fmt(cents, 0);
        case 'amount_with_comma_separator': return fmt(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(cents, 2, "'", '.');
        case 'amount_with_period_and_space_separator': return fmt(cents, 2, ' ', '.');
        case 'amount_with_space_separator': return fmt(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return fmt(cents, 0, ' ', ',');
        default: return fmt(cents, 2);
      }
    });
  }
  M.formatMoney = formatMoney;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Drawers (menu, search, cart) ---------- */
  var lastFocus = null;
  function openDrawer(name) {
    var d = $('[data-mv-drawer="' + name + '"]');
    if (!d) return false;
    lastFocus = document.activeElement;
    d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mv-lock');
    var f = $('input, button, a', d.querySelector('.mv-drawer__panel'));
    setTimeout(function () { if (name === 'search') { var i = $('input[type=search]', d); if (i) i.focus(); } else if (f) f.focus(); }, 60);
    return true;
  }
  function closeDrawers() {
    $$('.mv-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.body.classList.remove('mv-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  M.openDrawer = openDrawer; M.closeDrawers = closeDrawers;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-mv-open]');
    if (opener) {
      var name = opener.getAttribute('data-mv-open');
      if (name === 'cart') { e.preventDefault(); refreshCart().then(function () { openDrawer('cart'); }); return; }
      if (openDrawer(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-mv-close]')) { e.preventDefault(); closeDrawers(); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Smooth scroll to product for CTA buttons ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-mv-scroll]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href === '#MainContent' || href === '' || href === '#') {
      var target = $('[data-mv-product-section]') || $('#MainContent');
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    }
  });

  /* ---------- Cart API ---------- */
  function fetchJSON(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign({ 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) { var err = new Error(data.description || data.message || 'Something went wrong'); err.data = data; throw err; }
        return data;
      });
    });
  }
  function applyDiscountCode(code) {
    if (!code) return Promise.resolve();
    // Visiting /discount/CODE stores the code in the session so it's applied at checkout
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  }

  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function renderCart(cart) {
    $$('[data-mv-cart-count]').forEach(function (el) { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
    var drawer = $('[data-mv-drawer="cart"]');
    if (!drawer) return cart;
    var list = $('[data-mv-cart-items]', drawer), foot = $('[data-mv-cart-foot]', drawer);
    if (!cart.items.length) {
      list.innerHTML = '<p class="mv-cart__empty">' + escapeHtml((drawer.querySelector('.mv-cart__empty') || {}).textContent || 'Your cart is empty.') + '</p>';
      foot.hidden = true;
    } else {
      list.innerHTML = cart.items.map(function (item, i) {
        var img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
        if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="mv-cart__variant">' + escapeHtml(item.variant_title) + '</div>' : '';
        var discs = (item.discounts || []).map(function (d) { return '<div class="mv-cart__disc">🏷️ ' + escapeHtml(d.title) + ' (−' + formatMoney(d.amount) + ')</div>'; }).join('');
        var was = item.original_line_price > item.final_line_price ? '<s>' + formatMoney(item.original_line_price) + '</s>' : '';
        return '<div class="mv-cart__item" data-line="' + (i + 1) + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="72" height="72">' : '<span></span>') +
          '<div><a class="mv-cart__name" href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>' + variant + discs +
          '<div class="mv-cart__qty"><button type="button" data-mv-qty-change="-1" aria-label="Decrease quantity"><svg viewBox="0 0 24 24" class="mv-icon" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg></button>' +
          '<span>' + item.quantity + '</span><button type="button" data-mv-qty-change="1" aria-label="Increase quantity"><svg viewBox="0 0 24 24" class="mv-icon" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 5v14M5 12h14"/></svg></button></div></div>' +
          '<div class="mv-cart__line-price">' + formatMoney(item.final_line_price) + was + '<button type="button" class="mv-cart__remove" data-mv-remove>Remove</button></div>' +
          '</div>';
      }).join('');
      foot.hidden = false;
    }
    var total = $('[data-mv-cart-total]', drawer); if (total) total.textContent = formatMoney(cart.total_price);
    var discWrap = $('[data-mv-cart-discounts]', drawer);
    if (discWrap) {
      discWrap.innerHTML = (cart.cart_level_discount_applications || []).map(function (d) {
        return '<div><span>🏷️ ' + escapeHtml(d.title) + '</span><span>−' + formatMoney(d.total_allocated_amount) + '</span></div>';
      }).join('');
    }
    // Free shipping progress
    var threshold = parseInt(drawer.getAttribute('data-free-threshold') || '0', 10);
    var prog = $('[data-mv-progress]', drawer);
    if (prog && threshold > 0) {
      var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
      var goal = Math.round(threshold * rate);
      var left = goal - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / goal) * 100));
      $('[data-mv-progress-bar]', prog).style.width = pct + '%';
      $('[data-mv-progress-text]', prog).innerHTML = left > 0
        ? escapeHtml(drawer.getAttribute('data-free-text')).replace('[amount]', '<strong>' + formatMoney(left) + '</strong>')
        : escapeHtml(drawer.getAttribute('data-free-done'));
    }
    return cart;
  }
  function refreshCart() {
    return fetchJSON(routes().cartJs, { method: 'GET' }).then(renderCart).catch(function () {});
  }
  M.refreshCart = refreshCart;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mv-qty-change], [data-mv-remove]');
    if (!btn) return;
    var row = btn.closest('[data-line]'); if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var current = parseInt($('.mv-cart__qty span', row).textContent, 10);
    var qty = btn.hasAttribute('data-mv-remove') ? 0 : Math.max(0, current + parseInt(btn.getAttribute('data-mv-qty-change'), 10));
    var panel = btn.closest('.mv-cart'); if (panel) panel.classList.add('is-busy');
    fetchJSON(routes().cartChange, { method: 'POST', body: JSON.stringify({ line: line, quantity: qty }) })
      .then(renderCart)
      .finally(function () { if (panel) panel.classList.remove('is-busy'); });
  });

  /* ---------- Product section ---------- */
  function initProduct(section) {
    var jsonEl = $('[data-mv-product-json]', section);
    if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var form = $('[data-mv-form]', section);
    var idInput = $('[data-mv-variant-id]', section);
    var qtyInput = $('[data-mv-qty]', section);
    var atc = $('[data-mv-atc]', section);
    var buyNow = $('[data-mv-buynow]', section);
    var errorEl = $('[data-mv-error]', section);
    var variant = product.variants.find(function (v) { return idInput && String(v.id) === String(idInput.value); }) || product.variants[0];

    /* Gallery */
    var gallery = $('[data-mv-gallery]', section);
    var track = gallery && $('[data-mv-track]', gallery);
    var slides = track ? $$('.mv-gallery__slide', track) : [];
    var thumbs = gallery ? $$('.mv-gallery__thumb', gallery) : [];
    var dotsWrap = gallery && $('[data-mv-dots]', gallery);
    var current = 0;
    if (dotsWrap && slides.length > 1) dotsWrap.innerHTML = slides.map(function () { return '<span></span>'; }).join('');
    var dots = dotsWrap ? $$('span', dotsWrap) : [];
    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && t.parentNode) {
        var p = t.parentNode, left = t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2;
        p.scrollTo({ left: left, behavior: 'smooth' });
      }
    }
    function goTo(i) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }
    if (track) {
      var ticking = false;
      track.addEventListener('scroll', function () {
        if (ticking) return; ticking = true;
        requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current) setActive(i);
          ticking = false;
        });
      }, { passive: true });
      setActive(0);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-index'), 10)); }); });
    var prev = gallery && $('[data-mv-prev]', gallery), next = gallery && $('[data-mv-next]', gallery);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    if (slides.length < 2) { if (prev) prev.hidden = true; if (next) next.hidden = true; }

    /* Offers */
    var offers = $$('.mv-offer', section);
    function selectedOffer() {
      var r = $('.mv-offer__radio:checked', section);
      if (!r && !$('.mv-offer__radio', section) && qtyInput) {
        // No Mavora offers on the page (e.g. a bundle app sets the quantity instead)
        return { qty: parseInt(qtyInput.value, 10) || 1, discount: 0, code: '' };
      }
      return r ? { qty: parseInt(r.getAttribute('data-qty'), 10) || 1, discount: parseFloat(r.getAttribute('data-discount')) || 0, code: r.getAttribute('data-code') || '' } : { qty: 1, discount: 0, code: '' };
    }
    function updateOffers() {
      offers.forEach(function (label) {
        var r = $('.mv-offer__radio', label);
        label.classList.toggle('is-selected', r.checked);
        var qty = parseInt(r.getAttribute('data-qty'), 10) || 1;
        var disc = parseFloat(r.getAttribute('data-discount')) || 0;
        var base = variant.price * qty;
        var total = Math.round(base * (100 - disc) / 100);
        var save = base - total;
        var p = $('[data-mv-offer-price]', label); if (p) p.textContent = formatMoney(total);
        var c = $('[data-mv-offer-compare]', label); if (c) { c.textContent = formatMoney(base); c.hidden = save <= 0; }
        var s = $('[data-mv-offer-save]', label); if (s) s.textContent = formatMoney(save);
      });
      var o = selectedOffer();
      if (qtyInput) qtyInput.value = o.qty;
      $$('[data-mv-gifts]', section).forEach(function (g) {
        var min = parseInt(g.getAttribute('data-min-qty'), 10) || 1;
        g.hidden = o.qty < min;
      });
      var sticky = $('[data-mv-sticky-price]', section);
      if (sticky) sticky.textContent = formatMoney(Math.round(variant.price * o.qty * (100 - o.discount) / 100));
    }
    offers.forEach(function (label) { $('.mv-offer__radio', label).addEventListener('change', updateOffers); });

    /* Variants */
    var optionInputs = $$('[data-mv-opt-input]', section);
    function currentOptions() {
      var opts = [];
      $$('[data-mv-option]', section).forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-mv-option'), 10);
        var checked = $('input:checked', fs);
        opts[idx] = checked ? checked.value : null;
      });
      return opts;
    }
    function updateAvailability() {
      // Grey out option values with no available variant (given other selections)
      var sel = currentOptions();
      $$('[data-mv-option]', section).forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-mv-option'), 10);
        $$('input', fs).forEach(function (input) {
          var test = sel.slice(); test[idx] = input.value;
          var ok = product.variants.some(function (v) { return v.available && v.options.every(function (o, k) { return test[k] == null || o === test[k]; }); });
          var label = input.nextElementSibling; if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    function onVariantChange() {
      var sel = currentOptions();
      var match = product.variants.find(function (v) { return v.options.every(function (o, k) { return sel[k] == null || o === sel[k]; }); });
      $$('[data-mv-option]', section).forEach(function (fs) {
        var c = $('input:checked', fs), lbl = $('[data-mv-opt-value]', fs);
        if (c && lbl) lbl.textContent = c.value;
      });
      updateAvailability();
      if (!match) { if (atc) { atc.disabled = true; } return; }
      variant = match;
      if (idInput) idInput.value = variant.id;
      var price = $('[data-mv-price]', section); if (price) price.textContent = formatMoney(variant.price);
      var cmp = $('[data-mv-compare]', section);
      if (cmp) { cmp.textContent = formatMoney(variant.compare_at_price); cmp.hidden = !(variant.compare_at_price > variant.price); }
      var badge = $('[data-mv-save-badge]', section);
      if (badge) {
        var pct = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
        badge.textContent = (badge.getAttribute('data-label') || '').replace('[percent]', pct);
        badge.hidden = pct <= 0;
      }
      var label = $('[data-mv-atc-label]', section);
      if (atc) atc.disabled = !variant.available;
      if (buyNow) buyNow.disabled = !variant.available;
      if (label) label.textContent = variant.available ? label.getAttribute('data-default') : label.getAttribute('data-soldout');
      if (variant.featured_media && slides.length) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') === String(variant.featured_media.id); });
        if (idx > -1) goTo(idx);
      }
      updateOffers();
      if (window.history && window.history.replaceState && !document.documentElement.classList.contains('shopify-design-mode')) {
        var url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    optionInputs.forEach(function (i) { i.addEventListener('change', onVariantChange); });
    M.selectColor = function (value) {
      var found = false;
      optionInputs.forEach(function (i) {
        if (!found && i.value.toLowerCase() === String(value).toLowerCase()) { i.checked = true; found = true; }
      });
      if (found) onVariantChange();
      return found;
    };

    /* Add to cart / buy now  (uses Dawn's cart drawer / notification when present) */
    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg; errorEl.hidden = !msg; }
    function dawnCart() { return document.querySelector('cart-drawer') || document.querySelector('cart-notification'); }
    function addToCart(withSections) {
      var o = selectedOffer();
      var cartEl = withSections ? dawnCart() : null;
      var body = { id: parseInt(idInput.value, 10), quantity: o.qty };
      if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
        body.sections = cartEl.getSectionsToRender().map(function (x) { return x.id; });
        body.sections_url = window.location.pathname;
        if (cartEl.setActiveElement) cartEl.setActiveElement(document.activeElement);
      }
      showError('');
      return applyDiscountCode(o.code).then(function () {
        return fetchJSON(routes().cartAdd, { method: 'POST', body: JSON.stringify(body) });
      }).then(function (res) { return { offer: o, res: res, cartEl: cartEl }; });
    }
    if (form) {
      form.addEventListener('submit', function (e) {
        if (form.getAttribute('data-mv-native') === 'true') return; // let the bundle app / Shopify handle it
        e.preventDefault();
        if (!atc || atc.disabled) return;
        atc.classList.add('is-loading'); atc.disabled = true;
        addToCart(true).then(function (r) {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mavora-product', productVariantId: idInput.value, cartData: r.res }); } catch (err) {}
          }
          if (r.cartEl && typeof r.cartEl.renderContents === 'function' && r.res.sections) {
            if (r.cartEl.classList.contains('is-empty')) r.cartEl.classList.remove('is-empty');
            r.cartEl.renderContents(r.res);
          } else if ($('[data-mv-drawer="cart"]')) {
            return refreshCart().then(function () { openDrawer('cart'); });
          } else {
            window.location.href = routes().cart;
          }
        })
          .catch(function (err) { showError(err.message); })
          .finally(function () { atc.classList.remove('is-loading'); atc.disabled = !variant.available; });
      });
    }
    if (buyNow) {
      buyNow.addEventListener('click', function () {
        buyNow.disabled = true;
        addToCart(false).then(function (r) {
          window.location.href = '/checkout' + (r.offer.code ? '?discount=' + encodeURIComponent(r.offer.code) : '');
        }).catch(function (err) { showError(err.message); buyNow.disabled = false; });
      });
    }

    /* Sticky add-to-cart bar */
    var sticky = $('[data-mv-sticky]', section);
    var buyArea = $('.mv-buy', section) || atc;
    if (sticky && buyArea && 'IntersectionObserver' in window) {
      var footer = document.querySelector('.mv-footer');
      var pastButtons = false, footerVisible = false;
      var setSticky = function () {
        var show = pastButtons && !footerVisible;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        document.body.classList.toggle('mv-sticky-on', show);
      };
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { pastButtons = !en.isIntersecting && en.boundingClientRect.top < 0; });
        setSticky();
      }).observe(buyArea);
      if (footer) new IntersectionObserver(function (entries) { entries.forEach(function (en) { footerVisible = en.isIntersecting; }); setSticky(); }).observe(footer);
      var sbtn = $('[data-mv-sticky-btn]', sticky);
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form && atc && !atc.disabled) { form.requestSubmit ? form.requestSubmit() : atc.click(); }
        else section.scrollIntoView({ behavior: 'smooth' });
      });
    }

    updateOffers();
    updateAvailability();
  }

  /* ---------- Color showcase → select variant ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mv-pick-color]');
    if (!b) return;
    var target = $('[data-mv-product-section]');
    // No buy box on this page (e.g. homepage): follow the link to the product page
    if (!target || !M.selectColor) return;
    e.preventDefault();
    M.selectColor(b.getAttribute('data-mv-pick-color'));
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Track order page ---------- */
  function initTrack(root) {
    if (!root || root.dataset.mvTrackReady) return;
    root.dataset.mvTrackReady = '1';
    var tabs = $$('[data-mv-track-tab]', root);
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        $$('[data-mv-track-panel]', root).forEach(function (p) { p.hidden = p.getAttribute('data-mv-track-panel') !== tab.getAttribute('data-mv-track-tab'); });
      });
    });
    var form = $('form[data-mv-track-panel]', root);
    if (!form) return;
    var input = $('[data-mv-track-input]', root), err = $('[data-mv-track-error]', root);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = (input.value || '').replace(/\s+/g, '').toUpperCase();
      if (!/^[A-Z0-9-]{6,40}$/.test(num)) { err.hidden = false; input.focus(); return; }
      err.hidden = true;
      var url = root.getAttribute('data-provider') === 'parcelsapp'
        ? 'https://parcelsapp.com/en/tracking/' + encodeURIComponent(num)
        : 'https://t.17track.net/en#nums=' + encodeURIComponent(num);
      window.open(url, '_blank', 'noopener');
    });
  }

  /* ---------- Delivery dates ---------- */
  function addDays(date, n, skipWeekends) {
    var d = new Date(date.getTime());
    if (!skipWeekends) { d.setDate(d.getDate() + n); return d; }
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmtDate(d) {
    var lang = document.documentElement.lang || 'en';
    var month = d.toLocaleDateString(lang, { month: 'short' });
    var day = d.getDate();
    if (lang.indexOf('en') === 0) {
      var s = (day % 10 === 1 && day !== 11) ? 'st' : (day % 10 === 2 && day !== 12) ? 'nd' : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
      return month.replace('.', '') + ' ' + day + s;
    }
    return d.toLocaleDateString(lang, { day: 'numeric', month: 'short' });
  }
  function initDelivery(el) {
    var now = new Date(), skip = el.getAttribute('data-skip-weekends') === 'true';
    var n = function (a) { return parseInt(el.getAttribute(a), 10) || 0; };
    var set = function (k, txt) { var t = $('[data-mv-date="' + k + '"]', el); if (t) t.textContent = txt; };
    var range = function (a, b) { return a === b ? fmtDate(addDays(now, a, skip)) : fmtDate(addDays(now, a, skip)) + ' - ' + fmtDate(addDays(now, b, skip)); };
    set('ordered', fmtDate(now));
    set('ready', range(n('data-ready-min'), Math.max(n('data-ready-min'), n('data-ready-max'))));
    set('delivered', range(n('data-del-min'), Math.max(n('data-del-min'), n('data-del-max'))));
  }

  /* ---------- Video strip ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mv-vplay]');
    var vid = btn ? btn.parentNode.querySelector('video') : (e.target.closest('.mv-vstrip__video'));
    if (!vid) return;
    var item = vid.closest('.mv-vstrip__item');
    if (vid.paused) {
      $$('.mv-vstrip__video').forEach(function (v) { if (v !== vid) { v.pause(); var it = v.closest('.mv-vstrip__item'); if (it) it.classList.remove('is-playing'); } });
      vid.muted = false;
      var p = vid.play(); if (p && p.catch) p.catch(function () { vid.muted = true; vid.play(); });
      if (item) item.classList.add('is-playing');
    } else {
      vid.pause();
      if (item) item.classList.remove('is-playing');
    }
  });
  function initVStrip(track) {
    var bar = track.parentNode.querySelector('[data-mv-vbar]');
    if (!bar) return;
    var upd = function () {
      var max = track.scrollWidth - track.clientWidth;
      var vis = track.clientWidth / Math.max(1, track.scrollWidth);
      bar.style.width = Math.max(15, vis * 100) + '%';
      bar.style.marginLeft = (max > 0 ? (track.scrollLeft / max) * (100 - Math.max(15, vis * 100)) : 0) + '%';
      bar.parentNode.hidden = max <= 2;
    };
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- Review slider arrows ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mv-rprev], [data-mv-rnext]');
    if (!b) return;
    var track = b.closest('[data-mv-rslider]').querySelector('[data-mv-rtrack]');
    var card = track.firstElementChild;
    var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    track.scrollBy({ left: b.hasAttribute('data-mv-rnext') ? step : -step, behavior: 'smooth' });
  });

  /* ---------- Ships-by date ---------- */
  function initShipBy(el) {
    var days = parseInt(el.getAttribute('data-days'), 10) || 0;
    var d = addDays(new Date(), days, el.getAttribute('data-skip-weekends') === 'true');
    var t = $('[data-mv-shipby-date]', el);
    if (t) t.textContent = fmtDate(d);
  }

  /* ---------- Back to top ---------- */
  function initToTop() {
    var b = $('[data-mv-totop]'); if (!b) return;
    var onScroll = function () { b.classList.toggle('is-visible', window.scrollY > 900); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    b.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  /* ---------- Init ---------- */
  function init() {
    $$('[data-mv-product-section]').forEach(initProduct);
    $$('[data-mv-delivery]').forEach(initDelivery);
    $$('[data-mv-shipby]').forEach(initShipBy);
    $$('[data-mv-vstrip]').forEach(initVStrip);
    $$('[data-mv-track]').forEach(initTrack);
    initToTop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Re-initialise when sections are edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-mv-product-section]', e.target).forEach(initProduct);
    $$('[data-mv-delivery]', e.target).forEach(initDelivery);
    $$('[data-mv-shipby]', e.target).forEach(initShipBy);
    $$('[data-mv-vstrip]', e.target).forEach(initVStrip);
    $$('[data-mv-track]', e.target).forEach(initTrack);
  });
})();
